const apply_grade = [
	{ label: '一年级', value: 1 },
	{ label: '二年级', value: 2 },
	{ label: '三年级', value: 3 },
	{ label: '四年级', value: 4 },
	{ label: '五年级', value: 5 },
	{ label: '六年级', value: 6 },
	{ label: '初一', value: 7 },
	{ label: '初二', value: 8 },
	{ label: '初三', value: 9 },
	{ label: '高一', value: 10 },
	{ label: '高二', value: 11 },
	{ label: '高三', value: 12 }
]
const typeList = [
	{ label: '单选题', value: 1 },
	{ label: '多选题', value: 2 },
	{ label: '填空题', value: 3 },
	{ label: '连线题', value: 11 }
]
const fb_apply_volume = [
	{ label: '上册', value: 1 },
	{ label: '下册', value: 2 },
	{ label: '全部', value: 3 }
]
const difficultyList = [
	{ label: '容易', value: '容易' },
	{ label: '简单', value: '简单' },
	{ label: '困难', value: '困难' }
]

export { apply_grade, typeList, fb_apply_volume, difficultyList }
